import React from 'react';
import LoginForm from '../auth/LoginForm';

const AdminLogin = () => (
  <LoginForm
    title="Admin Login"
    subtitle="Enter your credentials to access the admin dashboard"
    redirectTo="/admin/dashboard"
  />
);

export default AdminLogin;
